import styled from 'styled-components';
import { animation } from 'utils';

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
  font-size: 1.1rem;
  border-radius: 2rem;
  margin: 1rem;
  padding: 1.5rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
`;

export const Popup = styled.div`
  height: 55vh;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 3rem;
  padding: 3rem 1rem;
  animation: ${animation.slideUp} 1s 300ms backwards;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  font-size: 1.1rem;
  text-align: center;
  z-index: 1;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Title = styled.span`
  font-size: 1.5em;
  font-weight: 800;
`;

export const Description = styled.span`
  font-weight: 600;
`;

export const NoThanks = styled.span`
  font-weight: 600;
  text-decoration: underline;
`;

export const Tap = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: black;
  color: white;
  gap: 0.5rem;
  padding: 0.5rem 2.5rem;
  border-radius: 1rem;
  font-size: 1em;
  font-weight: 800;
`;
